import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import countryCodes from "../../datas/countrydata.json";
import { PhoneInputProps } from "../../types/home";

const PhoneInput = ({
  placeholder,
  phoneNumber,
  countryCode,
  phoneInputRef,
  require = true,
  onPhoneNumberChange,
  onCountryCodeChange,
}: PhoneInputProps) => {
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState("");

  const selectedCountry = countryCodes.OldCountry.find(
    (c) => c.code === countryCode
  );

  const filteredCountries = countryCodes.OldCountry.filter((c) =>
    c.country.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div className="input-group mb-3 align-items-start">
        <div
          className="input-group-text text-black-50 bg-white font-13 ff-bold custom-select"
          onClick={() => setShowModal(true)}
          style={{ cursor: "pointer" }}
        >
          {selectedCountry?.iso && (
            <span
              className={`flag-icon flag-icon-${selectedCountry.iso.toLowerCase()} me-2`}
              style={{ width: "20px", height: "15px" }}
            />
          )}
          <span className="font-13 ff-semibold text-black">{countryCode}</span>

          <div className="ms-2">
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="#676767"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        <div className="up-form up-form flex-grow-1">
          <div className="form-group p-0 m-0 login-number-wrap">
            <input
              ref={phoneInputRef}
              type="tel"
              inputMode="numeric"
              className="form-control py-3 font-12 login-number"
              placeholder={placeholder}
              aria-label="Mobile Number"
              aria-describedby="basic-addon1"
              value={phoneNumber}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d*$/.test(input) && input.length <= 12) {
                  onPhoneNumberChange(input);
                }
              }}
              required={require}
            />
            <label>{placeholder ?? "Enter Mobile Number"}</label>
          </div>
        </div>
      </div>

      {/* Modal for country selection */}
      <Modal
        show={showModal}
        scrollable
        onHide={() => setShowModal(false)}
        centered
        className="mb-fix slide-from-bottom"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="rounded pb-4 p-0 modal-dialog-scrollable custom-modal-dialog">
          <div>
            <p className="font-21 text-center my-2 text-black mb-0 ff-bold">
              Select country
            </p>
            <div className="sticky-top bg-white p-3 pb-1">
              <input
                type="text"
                className="form-control  "
                placeholder="Search country"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="country-list p-3">
              {filteredCountries.map((c, i) => (
                <div
                  key={i}
                  className="d-flex gap-2 align-items-center py-2 px-2 border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onCountryCodeChange(c.code);
                    setShowModal(false);
                    setSearch("");
                  }}
                >
                  <div className="d-flex align-items-center">
                    {c.iso && (
                      <span
                        className={`flag-icon flag-icon-${c.iso.toLowerCase()} me-2`}
                        style={{ width: "20px", height: "15px" }}
                      />
                    )}
                    <span className="ff-semibold font-14 text-black">
                      {c.country}
                    </span>
                  </div>
                  <div className="ff-regular text-muted font-13">{c.code}</div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhoneInput;
